<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import NextInput from 'dashboard/components-next/input/Input.vue';

const product = defineModel({ type: Object, default: null });

const { t } = useI18n();

const name = computed({
  get: () => product.value?.name || '',
  set: value => {
    product.value = { ...(product.value || {}), name: value };
  },
});

const description = computed({
  get: () => product.value?.description || '',
  set: value => {
    product.value = { ...(product.value || {}), description: value };
  },
});

const price = computed({
  get: () => product.value?.price || '',
  set: value => {
    product.value = { ...(product.value || {}), price: value };
  },
});

const thumbnailPreview = ref('');

const handleThumbnailChange = event => {
  const file = event.target.files?.[0];
  if (!file) return;
  product.value = { ...(product.value || {}), thumbnailFile: file };
  thumbnailPreview.value = URL.createObjectURL(file);
};
</script>

<template>
  <div class="flex flex-col gap-5">
    <p class="text-sm text-n-slate-11">
      {{ t('QUICK_SETUP.STEP_PRODUCT.DESCRIPTION') }}
    </p>

    <div class="flex items-center gap-4">
      <div
        class="flex items-center justify-center overflow-hidden border rounded-lg size-20 border-n-weak bg-n-solid-2 shrink-0"
      >
        <img
          v-if="thumbnailPreview"
          :src="thumbnailPreview"
          class="object-cover w-full h-full"
        />
        <span v-else class="text-n-slate-9 i-lucide-image size-6" />
      </div>
      <label class="text-sm cursor-pointer text-n-blue-11 hover:underline">
        {{ t('QUICK_SETUP.STEP_PRODUCT.UPLOAD_THUMBNAIL') }}
        <input
          type="file"
          accept="image/*"
          class="hidden"
          @change="handleThumbnailChange"
        />
      </label>
    </div>

    <NextInput
      v-model="name"
      type="text"
      :label="t('QUICK_SETUP.STEP_PRODUCT.NAME_LABEL')"
      :placeholder="t('QUICK_SETUP.STEP_PRODUCT.NAME_PLACEHOLDER')"
    />
    <NextInput
      v-model="description"
      type="text"
      :label="t('QUICK_SETUP.STEP_PRODUCT.DESCRIPTION_LABEL')"
      :placeholder="t('QUICK_SETUP.STEP_PRODUCT.DESCRIPTION_PLACEHOLDER')"
    />
    <NextInput
      v-model="price"
      type="number"
      :label="t('QUICK_SETUP.STEP_PRODUCT.PRICE_LABEL')"
      placeholder="0,00"
    />
    <p class="text-xs text-n-slate-10">
      {{ t('QUICK_SETUP.STEP_PRODUCT.SKIP_HINT') }}
    </p>
  </div>
</template>
